export default "__VITE_ASSET__hKwkJZQ8__"